import { render, staticRenderFns } from "./c_input_item.vue?vue&type=template&id=6dea7fc6&scoped=true"
import script from "./c_input_item.vue?vue&type=script&lang=js"
export * from "./c_input_item.vue?vue&type=script&lang=js"
import style0 from "./c_input_item.vue?vue&type=style&index=0&id=6dea7fc6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea7fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dea7fc6')) {
      api.createRecord('6dea7fc6', component.options)
    } else {
      api.reload('6dea7fc6', component.options)
    }
    module.hot.accept("./c_input_item.vue?vue&type=template&id=6dea7fc6&scoped=true", function () {
      api.rerender('6dea7fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_input_item.vue"
export default component.exports